import React from 'react';

import { Link } from 'react-router-dom';

const createBillsListTableCell = (value, row) => {
  if (!row._bills || row._bills.length === 0) {
    return '';
  }

  // Limit to the first two bills and check if there are more than two
  const firstTwoBills = row._bills.slice(0, 2);
  const moreThanTwo = row._bills.length > 2;

  const billLinks = firstTwoBills
    .map((bill) => (
      <Link
        key={bill.id}
        className="text-blue-600 underline"
        to={`/loans/${bill.loan_id}/bills/${bill.id}?tab=Bill`}
      >
        {bill.pixel_bill_number || bill.id}
      </Link>
    ))
    .reduce((prev, curr) => (prev ? [prev, ', ', curr] : [curr]), '');

  // Add a "(more)" link if there are more than two bills
  return (
    <>
      {billLinks}
      {moreThanTwo && (
        <Link
          className="text-blue-600 underline"
          to={`/bill-payments/${row.id}`}
        >
          {'  '}(more)
        </Link>
      )}
    </>
  );
};

export default createBillsListTableCell;
